module.exports = __webpack_public_path__ + "img/stronger_light.2d6ffefa.png";